<template>
    <div class="select-viewer-dialog">
        <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
            <div class="top-input-container">
                <div class="top-item">
                    <el-radio-group v-model="convertType" @change="changeConvertType">
                        <el-radio-button label="obv">全量</el-radio-button>
                        <el-radio-button label="lod">流式</el-radio-button>
                    </el-radio-group>
                    <el-input
                        class="dialog-filter-input"
                        placeholder="输入关键字进行搜索"
                        prefix-icon="el-icon-search"
                        v-model="filterText"
                        @input="filterObjectsList"
                        :clearable="true"
                    >
                    </el-input>
                </div>
                <div class="bottom-item">
                    <el-input class="dialog-name" placeholder="请输入内容" v-model.trim="input">
                        <template slot="prepend">{{ headerName }}：</template>
                    </el-input>
                </div>
            </div>

            <div class="dialog-body">
                <div class="bucket-tree">
                    <!--                <div class="object-header">Bucket列表</div>-->
                    <el-tree
                        default-expand-all
                        :data="[bucketsTree]"
                        :props="defaultProps"
                        @node-click="handleNodeClick"
                        :highlight-current="true"
                    ></el-tree>
                </div>
                <div class="object-list" v-loading="isLoading">
                    <div class="object-header">文件名称</div>
                    <div class="object-list-container" v-if="filterObjects.length > 0">
                        <div
                            v-for="item in filterObjects"
                            :key="item.fileName"
                            :class="{
                                'object-list-item': true,
                                'selected-object': item.fileName === activeObject.fileName,
                            }"
                            @click="handleObject(item)"
                        >
                            {{ item.fileName }}
                        </div>
                    </div>
                    <el-empty description="没有文件" v-if="filterObjects.length < 1"></el-empty>
                </div>
                <div class="viewer-tree">
                    <div class="object-header">视图列表</div>
                    <el-tree
                        :data="viewList"
                        :props="viewDefaultProps"
                        default-expand-all
                        v-loading="isLoadingViewerTree"
                        class="tree"
                    >
                        <span slot-scope="{ node, data }">
                            <span>{{ node.label }}</span>
                            <span v-if="node.isLeaf">
                                <el-button
                                    class="tree-node-button"
                                    type="text"
                                    size="mini"
                                    @click="() => addView(data)"
                                >
                                    添加
                                </el-button>
                            </span>
                        </span>
                    </el-tree>
                </div>
            </div>
            <slot></slot>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="beginStatus" @click="ok">开 始</el-button>
                <el-button @click="close">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getAllBucket, getObjectViewToken, getPageObjects } from '../../../../utils/modelUtils';
import { ModelDocumentUtils } from '../../../../utils/ModelDocumentUtils';
import { getAllJobStatus, newGetAllJobStatus, getJobType, getJobStatusForLod } from 'src/utils/jobUtils';
import { analysisFileType } from '../../../../utils/commonUtils';

export default {
    props: {
        dialogVisible: false,
        title: '',
        headerName: '',
        isShow2d: {
            default: true,
        },
        isShow3d: {
            default: true,
        },
        beginStatus: {
            default: false,
        },
        // isLodState: false,
    },
    data() {
        return {
            isLoading: false, // 控制加载
            input: '',
            defaultProps: {
                children: 'children',
                label: 'bucket_key',
            },
            viewDefaultProps: {
                children: 'children',
                label: 'name',
            },
            convertType: 'obv',
            activeBucketKey: '',
            activeObject: '',
            bucketsTree: { bucket_key: 'Bucket列表', open: true, children: [] },
            activeObjects: [],
            token: '',
            _modelDocumentUtils: ModelDocumentUtils,
            viewList: [],
            isLoadingViewerTree: false,
            // 筛选相关
            filterText: '',
            filterObjects: [],
            obvFilterObjects: [],
            lodFilterObjects: [],
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        ok() {
            this.$emit('ok', { name: this.input, convertType: this.convertType });
        },
        addView(data) {
            this.$emit('add-view', { view: data, object: this.activeObject, urn: this._getActiveUrn() });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    this.close();
                    // done();
                })
                .catch((_) => {});
        },
        handleNodeClick(data) {
            if (!data.id) {
                return;
            }
            this.isLoading = true;
            this.viewList = [];
            this.activeObject = '';
            this.activeBucketKey = data.bucket_key;
            this.getObjects(this.activeBucketKey);
        },
        handleObject(item) {
            this.getModelViewList(item);
        },
        async getModelViewList(item) {
            this.isLoadingViewerTree = true;
            this.activeObject = item;
            this.viewList = [];
            const fileInfo = {
                fileName: this.activeObject.fileName,
                convertType: this.convertType,
            };
            try {
                await this._modelDocumentUtils.init(this.token, this._getActiveUrn(), fileInfo);
                const viewList = this._modelDocumentUtils.getViewableItems(true);
                viewList.forEach((item) => {
                    if (this.isShow3d) {
                        const list = this._modelDocumentUtils.get3dGeometryItems(item);
                        if (list && list.length > 0) {
                            item.children;
                            this.viewList.push({ ...item, children: list });
                        }
                    }
                    if (this.isShow2d) {
                        const list = this._modelDocumentUtils.get2dGeometryItems(item);
                        if (list && list.length > 0) {
                            item.children;
                            this.viewList.push({ ...item, children: list });
                        }
                    }
                });
            } catch (err) {
                this.viewList = [];
            }
            this.isLoadingViewerTree = false;
        },
        async init() {
            this.isLoading = true;
            const { data } = await getAllBucket();
            data.buckets = data.buckets.filter((item) => item.bucket_key !== 'translation_result_v2');
            this.bucketsTree.children = data.buckets;
            if (data.buckets[0]) {
                this.activeBucketKey = data.buckets[0].bucket_key;
                this.getObjects(this.activeBucketKey);
            }
        },
        async getObjects(bucketKey) {
            // 过滤出有三维视图的模型，图片、图纸等不能进行组装
            if (bucketKey === this.activeBucketKey) {
                let data = {
                    viewType: '3d',
                };
                const list = await getPageObjects(bucketKey, data);
                if (list.data) {
                    this.getAllJobStatusFun(list.data);
                } else {
                    this.filterObjects = this.activeObjects = [];
                    this.isLoading = false;
                }
            }
        },
        // 获取所有的文件并分组
        getAllJobStatusFun(temp) {
            newGetAllJobStatus(this.activeBucketKey, temp).then((res) => {
                if (res) {
                    let tempObvFilterObjects = [],
                        tempLodFilterObjects = [];
                    for (let index in res.data) {
                        const tempNameArr = index.split('/');
                        if (res.data[index].obv && res.data[index].obv.state === 'complete') {
                            tempObvFilterObjects.push({ fileName: tempNameArr[tempNameArr.length - 1] });
                        }
                        if (res.data[index].lod && res.data[index].lod.state === 'complete') {
                            tempLodFilterObjects.push({ fileName: tempNameArr[tempNameArr.length - 1] });
                        }
                    }
                    // 将获取到的文件信息分组
                    this.obvFilterObjects = tempObvFilterObjects;
                    this.lodFilterObjects = tempLodFilterObjects;
                    tempObvFilterObjects = tempLodFilterObjects = [];
                    // 根据按钮展示不同的分组
                    if (this.convertType === 'obv') {
                        this.filterObjects = this.activeObjects = this.obvFilterObjects;
                    } else {
                        this.filterObjects = this.activeObjects = this.lodFilterObjects;
                    }
                }
                this.isLoading = false;
            });
        },
        changeConvertType() {
            if (this.convertType === 'obv') {
                this.filterObjects = this.activeObjects = this.obvFilterObjects;
            } else {
                this.filterObjects = this.activeObjects = this.lodFilterObjects;
            }
            this.viewList = [];
            this.isLoadingViewerTree = false;
            this.filterText = '';
            this.$emit('remove-all-view');
        },
        _getActiveUrn() {
            return `urn:bimbox.object:${this.activeBucketKey}/${this.activeObject.fileName}`;
        },
        filterObjectsList() {
            this.filterObjects = this.activeObjects.filter((dataNews) => {
                return Object.keys(dataNews).some((key) => {
                    return String(dataNews['fileName']).indexOf(this.filterText) > -1;
                });
            });
        },
    },
    mounted() {
        this.init();
        getObjectViewToken().then((res) => {
            this.token = res.data.newToken;
        });
        this._modelDocumentUtils = new ModelDocumentUtils();
    },
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
$color-bgc = #f7f7f7
.select-viewer-dialog
  .el-dialog__body
    padding-top 10px
  .top-input-container
    margin-bottom 5px
    .top-item
      display flex
      justify-content space-between
      margin-bottom 5px
    .dialog-filter-input
      width 30%
  .dialog-body
    display flex
    background-color #FFFFFF
    height 300px
    .bucket-tree
      overflow auto
      background-color $color-bgc
      flex 1
      .el-tree
        background-color $color-bgc
        .el-tree-node__content:hover, .el-tree-node:focus > .el-tree-node__content
          background-color rgba(64, 158, 255, 0.58)
    .object-list
      margin 0 10px
      flex 2
      text-align center
      .object-list-container
        height 266px
        overflow auto
        .object-list-item
          box-sizing border-box
          padding 10px 0
          cursor pointer
        .object-list-item:hover
          background-color #d1e1fd
          color #184db4
          border-color #9abaee !important
        :nth-child(even)
          background-color $color-bgc
          border 1px solid $color-bgc
        :nth-child(odd)
          background-color #FFFFFF
          border 1px solid #FFFFFF
    .object-header
      background-color $color-bgc
      font-weight 700
      padding 10px 15px
    .viewer-tree
      overflow auto
      background-color $color-bgc
      flex 1
      .tree
        display flex
        .tree-node-button
          margin-right 10px
          cursor pointer
    .selected-object
      background-color #d1e1fd !important
      color #184db4
      border-color #9abaee !important
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/ModelAssemble/SelectViewerDialog.vue